import React, { SelectHTMLAttributes } from 'react';

import { RequiredAsterisk } from 'components/ui/RequiredAsterisk';

import { ChevronSmall } from 'components/svg/ChevronSmall';

import { colors, FontColorProps, Fonts, spacing } from 'styles/theme';
import { Bumper, Label, SubLabel } from 'styles/shared';
import {
    Select as StyledSelect,
    DropdownArrowWrapper,
    SelectWrapper,
    SelectProps as StyledSelectProps,
} from 'styles/select';

type HTMLSelectCustomProps = SelectHTMLAttributes<HTMLSelectElement> &
    FontColorProps;
interface SelectProps extends HTMLSelectCustomProps, StyledSelectProps {
    label?: string;
    subLabel?: string;
    $isAltText?: boolean;
}

export const Select = (props: SelectProps) => {
    const { label, required, subLabel, value, $isAltText } = props;

    return (
        <SelectWrapper>
            {$isAltText ? (
                <>
                    {label == null ? null : (
                        <Fonts.Medium $isOpenSansSemiBold>{label}</Fonts.Medium>
                    )}
                    {subLabel == null ? null : (
                        <Fonts.Medium>
                            {subLabel}
                            {required ? <RequiredAsterisk /> : null}
                        </Fonts.Medium>
                    )}
                    <Bumper $minHeight={spacing.xxSmall} />
                </>
            ) : (
                <>
                    {label == null ? null : (
                        <Label>
                            {label}
                            {required ? <RequiredAsterisk /> : null}
                        </Label>
                    )}
                    {subLabel == null ? null : <SubLabel>{subLabel}</SubLabel>}
                </>
            )}
            <StyledSelect
                {...props}
                $color={
                    value != null && value !== ''
                        ? colors.darkJungle
                        : colors.grey30
                }
            />
            <DropdownArrowWrapper>
                <ChevronSmall />
            </DropdownArrowWrapper>
        </SelectWrapper>
    );
};
